import { Checkbox as MantineCheckbox } from '@mantine/core';
import { FC, memo } from 'react';
import { useFormContext } from 'src/form';

import styles from './styles.module.css';

type Props = {
  label: React.ReactNode;
  name: string;
};

export const Checkbox: FC<Props> = memo(({ label, name }) => {
  const form = useFormContext();

  const formProps = form.getInputProps(name);

  return (
    <MantineCheckbox
      classNames={{
        error: styles.checkboxError,
        icon: styles.checkboxIcon,
        input: styles.checkboxInput,
        label: styles.checkboxLabel,
      }}
      label={label}
      size="md"
      {...formProps}
    />
  );
});
